if (!customElements.get('mmx-sales-product')) {
  customElements.define(
    'mmx-sales-product',
    class MMXSalesProduct extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-sales-review-track]');
        this.cards = Array.from(this.querySelectorAll('.mmx-sales-review'));
        this.dots = Array.from(this.querySelectorAll('[data-sales-review-dot]'));

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.salesReviewDot)));
        });
        this.track?.addEventListener('scroll', () => this.updatePagination(), { passive: true });
      }

      goTo(index) {
        if (!this.cards[index]) return;
        this.cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }

      updatePagination() {
        if (!this.track || !this.cards.length) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const step = this.cards[0].offsetWidth + gap;
        const index = Math.min(this.cards.length - 1, Math.max(0, Math.round(this.track.scrollLeft / step)));
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }
  );
}
